export const FUNCTIONAL_COOKIE = 'r_func'
export const PERFORMANCE_COOKIE = 'r_perf'

export default {
  FUNCTIONAL_COOKIE,
  PERFORMANCE_COOKIE
}
